export default "__VITE_ASSET__CbvKPkhJ__"